import { PatientBalance } from "./Balance";
import * as React from "react";
import PatientBalanceView from "./PatientBalanceView";
import "./PatientBalanceList.scss";

export default function PatientBalanceList({ balances }: { balances: PatientBalance[] }) {
  return (
    <div className={"balance-list"}>
      {balances.map((balance) => (
        <PatientBalanceView {...balance} key={balance.patient.uid} />
      ))}
    </div>
  );
}
